@if (isFilter() && isMultiSelect()) {
  <!-- Multi-select filter mode -->
  <button
    class="filter-trigger"
    [class.filter-trigger--active]="isOpen()"
    [class.filter-trigger--has-value]="selectedValues().length > 0"
    [disabled]="effectiveDisabled()"
    cdkOverlayOrigin
    #triggerOrigin="cdkOverlayOrigin"
    #triggerRef
    role="combobox"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-disabled]="effectiveDisabled()"
    [attr.aria-controls]="panelId"
    [attr.aria-activedescendant]="activeOptionId()"
    aria-haspopup="listbox"
    (click)="openPanelMulti()"
    (keydown)="onTriggerKeydown($event)">
    <span class="filter-trigger__text">{{ multiSelectDisplayText() || effectiveLabel() || 'Seleccionar' }}</span>
    <svg class="filter-trigger__chevron" viewBox="0 0 24 24" fill="none">
      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="triggerOrigin"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="cancelMultiSelection()"
    (detach)="cancelMultiSelection()"
    (positionChange)="onPositionChange($event)">
    <div
      class="options-panel options-panel--filter options-panel--multiselect"
      [class.options-panel--above]="isAbove()"
      role="listbox"
      [attr.id]="panelId"
      (keydown)="onPanelKeydown($event)">
      @if (effectiveLabel()) {
        <div class="filter-panel-header">{{ effectiveLabel() }}</div>
      }
      @if (!hasNoItems() && !hideFilterSearch()) {
      <div class="multiselect-search">
        <div class="filter-search-container">
          <svg class="filter-search-icon" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M16 16L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input
            class="filter-search-input"
            type="text"
            placeholder="Buscar..."
            [value]="searchTerm()"
            (input)="onSearchChange($any($event.target).value)"
            (keydown)="onSearchKeydown($event)">
        </div>
      </div>
      }
      @if (!hasNoItems()) {
      <div class="multiselect-select-all" (click)="toggleSelectAll()">
        <div class="multiselect-checkbox" [class.checked]="allSelected()" [class.indeterminate]="someSelected()">
          @if (allSelected()) {
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          }
          @if (someSelected() && !allSelected()) {
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          }
        </div>
        <span>Seleccionar todo</span>
      </div>
      }
      @if (hasNoItems() || hasNoSearchResults()) {
        <div class="options-empty" role="status">
          {{ hasNoItems() ? emptyMessage() : noResultsMessage() + ': “' + searchTerm() + '”' }}
        </div>
      }
      <cdk-virtual-scroll-viewport
        class="options-viewport"
        [itemSize]="itemSize()"
        [style.height.px]="panelHeight()"
        [style.overflow-y]="viewportOverflowY()"
        [minBufferPx]="itemSize()"
        [maxBufferPx]="itemSize() * 2">
        <div
          class="option-item option-item--multiselect"
          *cdkVirtualFor="let item of displayItems(); let index = index; trackBy: trackByKey"
          role="option"
          [attr.id]="getOptionId(index)"
          [class.active]="activeIndex() === index"
          [class.disabled]="shouldBeDisabled(item.key)"
          (click)="toggleItem(item)">
          <div class="multiselect-checkbox" [class.checked]="isItemSelected(item.key)">
            @if (isItemSelected(item.key)) {
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
          </div>
          <span [title]="item.value">{{ item.value }}</span>
        </div>
      </cdk-virtual-scroll-viewport>
      <div class="multiselect-actions">
        <button class="multiselect-btn multiselect-btn--cancel" (click)="cancelMultiSelection()">Cancelar</button>
        <button class="multiselect-btn multiselect-btn--apply" (click)="applyMultiSelection()">Aplicar</button>
      </div>
    </div>
  </ng-template>
} @else if (isFilter()) {
  <!-- Single select filter mode with checkbox style and apply button -->
  <button
    class="filter-trigger"
    [class.filter-trigger--active]="isOpen()"
    [class.filter-trigger--has-value]="currentDisplayItemSafe()"
    [class.filter-trigger--full-width]="fullWidth()"
    [disabled]="effectiveDisabled()"
    cdkOverlayOrigin
    #triggerOrigin="cdkOverlayOrigin"
    #triggerRef
    role="combobox"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-disabled]="effectiveDisabled()"
    [attr.aria-controls]="panelId"
    aria-haspopup="listbox"
    [attr.aria-activedescendant]="activeOptionId()"
    (click)="openPanelSingleFilter()"
    (keydown)="onTriggerKeydown($event)">
    <span class="filter-trigger__text">{{ currentDisplayItemSafe() || effectiveLabel() || 'Seleccionar' }}</span>
    @if (clearable()) {
      <span
        class="filter-trigger__clear"
        [class.filter-trigger__clear--hidden]="!currentDisplayItemSafe() || effectiveDisabled()"
        role="button"
        [attr.tabindex]="currentDisplayItemSafe() && !effectiveDisabled() ? 0 : -1"
        [attr.aria-hidden]="!currentDisplayItemSafe() || effectiveDisabled()"
        aria-label="Limpiar seleccion"
        (click)="clearSelection($event)"
        (keydown.enter)="clearSelection($event)"
        (keydown.space)="clearSelection($event)">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
        </svg>
      </span>
    }
    <svg class="filter-trigger__chevron" viewBox="0 0 24 24" fill="none">
      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="triggerOrigin"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="cancelSingleSelection()"
    (detach)="cancelSingleSelection()"
    (positionChange)="onPositionChange($event)">
    <div
      class="options-panel options-panel--filter options-panel--single-filter"
      [class.options-panel--above]="isAbove()"
      role="listbox"
      [attr.id]="panelId"
      (keydown)="onPanelKeydown($event)">
      @if (effectiveLabel()) {
        <div class="filter-panel-header">{{ effectiveLabel() }}</div>
      }
      @if (!hasNoItems() && !hideFilterSearch()) {
      <div class="multiselect-search">
        <div class="filter-search-container">
          <svg class="filter-search-icon" viewBox="0 0 24 24" fill="none">
            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
            <path d="M16 16L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          <input
            class="filter-search-input"
            type="text"
            placeholder="Buscar..."
            [value]="searchTerm()"
            (input)="onSearchChange($any($event.target).value)"
            (keydown)="onSearchKeydown($event)">
        </div>
      </div>
      }
      @if (hasNoItems() || hasNoSearchResults()) {
        <div class="options-empty" role="status">
          {{ hasNoItems() ? emptyMessage() : noResultsMessage() + ': “' + searchTerm() + '”' }}
        </div>
      }
      <cdk-virtual-scroll-viewport
        class="options-viewport"
        [itemSize]="itemSize()"
        [style.height.px]="panelHeight()"
        [style.overflow-y]="viewportOverflowY()"
        [minBufferPx]="itemSize()"
        [maxBufferPx]="itemSize() * 2">
        <div
          class="option-item option-item--single-filter"
          *cdkVirtualFor="let item of displayItems(); let index = index; trackBy: trackByKey"
          role="option"
          [attr.id]="getOptionId(index)"
          [class.active]="activeIndex() === index"
          [attr.aria-selected]="isTempSingleSelected(item.key)"
          [class.disabled]="shouldBeDisabled(item.key)"
          (click)="selectTempSingleItem(item)">
          <div class="multiselect-checkbox" [class.checked]="isTempSingleSelected(item.key)">
            @if (isTempSingleSelected(item.key)) {
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            }
          </div>
          <span [title]="item.value">{{ item.value }}</span>
        </div>
      </cdk-virtual-scroll-viewport>
      @if (!autoApply()) {
        <div class="multiselect-actions">
          <button class="multiselect-btn multiselect-btn--cancel" (click)="cancelSingleSelection()">Cancelar</button>
          <button class="multiselect-btn multiselect-btn--apply" (click)="applySingleSelection()">Aplicar</button>
        </div>
      }
    </div>
  </ng-template>
} @else {
  <!-- Standard form select -->
  <div class="select__form" [class.select__form--horizontal]="display() === 'horizontal'">
    @if (effectiveLabel() && display() !== 'horizontal') {
      <label class="select-label" [style]="labelStyle()">
        {{ effectiveLabel() }}
        @if (effectiveRequired()) {
          <span class="required-mark">*</span>
        }
      </label>
    }
    @if (effectiveLabel() && display() === 'horizontal') {
      <label class="inline-label" [style]="labelStyle()">
        {{ effectiveLabel() }}
        @if (effectiveRequired()) {
          <span class="required-mark">*</span>
        }
      </label>
    }
    <div class="select-container" [class.white-box]="isWhiteBox()">
      <div
        class="select-trigger"
        [class.custom-reactive-select-arrow]="!effectiveLoading() && actionButtons().length === 0"
        [class.select-trigger--has-actions]="actionButtons().length > 0"
        [class.disabled]="effectiveDisabled()"
        [class.open]="isOpen()"
        [style]="customStyle()"
        [style.--so-select-height.px]="selectHeight()"
        cdkOverlayOrigin
        #triggerOrigin="cdkOverlayOrigin"
        #triggerRef
        role="combobox"
        [attr.aria-expanded]="isOpen()"
        [attr.aria-disabled]="effectiveDisabled()"
        [attr.aria-controls]="panelId"
        aria-haspopup="listbox"
        [attr.aria-activedescendant]="activeOptionId()"
        [attr.tabindex]="effectiveDisabled() ? -1 : 0"
        (click)="onTriggerClick()"
        (keydown)="onTriggerKeydown($event)"
        [title]="effectiveDisabled() && tooltipDisabledText() ? tooltipDisabledText() : ''">
        @if (!currentDisplayItemSafe()) {
          <span class="placeholder">{{ placeholder() }}</span>
        }
        @if (currentDisplayItemSafe()) {
          <span class="selected-value text-truncate">{{ currentDisplayItemSafe() }}</span>
        }

        @if (clearable()) {
          <span
            class="select-trigger__clear"
            [class.select-trigger__clear--hidden]="!currentDisplayItemSafe() || effectiveDisabled()"
            role="button"
            [attr.tabindex]="currentDisplayItemSafe() && !effectiveDisabled() ? 0 : -1"
            [attr.aria-hidden]="!currentDisplayItemSafe() || effectiveDisabled()"
            aria-label="Limpiar seleccion"
            (click)="clearSelection($event)"
            (keydown.enter)="clearSelection($event)"
            (keydown.space)="clearSelection($event)">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
            </svg>
          </span>
        }

        @if (actionButtons().length > 0) {
          <div class="select-inline-actions" (click)="$event.stopPropagation()">
            @for (button of actionButtons(); track $index) {
              @if (button.show ?? true) {
                @if (button.isLoadingAI) {
                  <so-ai-loader-ui [size]="20"/>
                } @else {
                  <so-button-gradient-ui
                    [text]="''"
                    [icon]="button.icon"
                    [variant]="button.variant || 'outline'"
                    [color]="button.color || 'secondary'"
                    (clicked)="button.onClick()" />
                }
              }
            }
          </div>
        }
      </div>

      @if (currentDisplayItemSafe() !== null && displayValueStyle()) {
        <span [class]="'display-value text-truncate ' + displayValueClass()" [style]="displayValueStyle()">{{ currentDisplayItemSafe() }}</span>
      }

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="triggerOrigin"
        [cdkConnectedOverlayOpen]="isOpen()"
        [cdkConnectedOverlayPositions]="overlayPositions"
        [cdkConnectedOverlayFlexibleDimensions]="true"
        [cdkConnectedOverlayPush]="true"
        [cdkConnectedOverlayHasBackdrop]="true"
        [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
        (backdropClick)="closePanel()"
        (detach)="closePanel()"
        (positionChange)="onPositionChange($event)">
        <div
          class="options-panel"
          [class.options-panel--above]="isAbove()"
          [class.options-panel--searchable]="searchable()"
          role="listbox"
          [attr.id]="panelId"
          [style.height.px]="standardPanelHeight()"
          [style.max-height.px]="standardPanelHeight()"
          [style.min-width]="'max(' + (triggerWidth() || 0) + 'px, min(260px, calc(100vw - 32px)))'"
          (keydown)="onPanelKeydown($event)">
          @if (searchable() && !hasNoItems()) {
            <div class="multiselect-search">
              <div class="filter-search-container">
                <svg class="filter-search-icon" viewBox="0 0 24 24" fill="none">
                  <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.5"/>
                  <path d="M16 16L20 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <input
                  class="filter-search-input"
                  type="text"
                  placeholder="Buscar..."
                  [value]="searchTerm()"
                  (click)="$event.stopPropagation()"
                  (input)="onSearchChange($any($event.target).value)"
                  (keydown)="onSearchKeydown($event)">
              </div>
            </div>
          }
          @if (hasNoItems() || hasNoSearchResults()) {
            <div class="options-empty" role="status">
              {{ hasNoItems() ? emptyMessage() : noResultsMessage() + ': “' + searchTerm() + '”' }}
            </div>
          }
          @if (!hasNoItems() && !hasNoSearchResults()) {
            <cdk-virtual-scroll-viewport
              class="options-viewport"
              [itemSize]="itemSize()"
              [style.height.px]="standardViewportHeight()"
              [style.overflow-y]="standardViewportOverflowY()"
              [minBufferPx]="itemSize()"
              [maxBufferPx]="itemSize() * 2">
              <div
                class="option-item"
                *cdkVirtualFor="let item of displayItems(); let index = index; trackBy: trackByKey"
                role="option"
                [attr.id]="getOptionId(index)"
                [class.active]="activeIndex() === index"
                [attr.aria-selected]="normalizeKey(item.key) === normalizeKey(internalValue())"
                [class.selected]="internalValue() !== null && normalizeKey(item.key) === normalizeKey(internalValue())"
                [class.disabled]="shouldBeDisabled(item.key)"
                (click)="selectItem(item)">
                <span class="option-item__label" [attr.title]="item.value">{{ item.value }}</span>
              </div>
            </cdk-virtual-scroll-viewport>
          }
        </div>
      </ng-template>

      @if (effectiveLoading()) {
        <div class="spinner"></div>
      }
    </div>
  </div>
}
